<div class="user-business-wrapper">
    <div class="gt-page-body">
        <div class="row" style="margin: 0; border: 1px solid #ccc; border-radius: 3px;">
          <div class="full-panel">
            <!-- Client/Tax Year Filters and JCD Scenario Table -->
            <div class="col-md-4">
              <div class="client-content">
                <label>Client: <span>{{ userSettings?.user?.client?.client_name }}</span></label>
                <!-- <span style="flex: 1; margin-top: 3px;">Client: </span>
                <input type="text" class="form-control" [(ngModel)]="userSettings.user.client.client_name" [disabled]="true"> -->
                <!-- <select style="flex: 8" [disabled]="true" id="clientId" class="form-control input-sm" name="clientId"
                  (ngModelChange)="resetData(client_key)" [(ngModel)]="client_key"
                  [ngModelOptions]="{standalone: true}"
                  [ngValue]="client.client_key as client.client_name for client in clients" required></select> -->
                <!-- <span class="form-error-container" [hidden]="!clientId.dirty || !clientId.invalid || templateFrom.submitted">Client is required.</span> -->
              </div>
      
              @if (selectedGrpObjKeys.length > 0) {
<div style="margin: 10px 0px 0px 0px;">
                <ap-accordion-group [multiple]="true"
                                    [accordionId]="'user-business-hierarchy'"
                                    [styleClass]="'b-a-accordion'">
                  @for (anObj of uniqueBizzHierGrpObjDetails; track trackByGroupObjKey(index, anObj); let index = $index) {
                    <ap-accordion
                      [id]="'user-business-hierarchy-' + anObj.GROUP_OBJ_KEY"
                      [title]="getName(index, anObj)"
                      [expanded]="!!anObj.open"
                      (onClick)="onHierarchyAccordionToggle(anObj)">
                      <div class="accordion-body-content" (click)="$event.stopPropagation()">
                        <table class="table a-table-cont">
                          <thead>
                            <tr>
                              <th>Scenario</th>
                              <th>JCD Key</th>
                              <th>Application</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (row of bizzHierGrpObjDetails | filterObj: anObj.GROUP_OBJ_KEY; track $index) {
                              <tr>
                                <td><span class="badge btn-info">{{ row.SCENARIO }}</span>&nbsp;{{ row.SCENARIO_DESC }}</td>
                                <td><span class="badge btn-info">{{ row.JCD_KEY }}</span></td>
                                <td>{{ row.CHANNEL_KEY }}&nbsp;-&nbsp;{{ row.CHANNEL_NAME }}</td>
                                <td><i class="fa fa-external-link fa-link-style" [ngClass]="{'active-color': row.selected}"
                                    (click)="updateSelectedGroupObjKeys(row.GROUP_OBJ_KEY, row.TAX_YEAR, row.SCENARIO, row.JCD_KEY)"
                                    id="chk_{{ row.GROUP_OBJ_KEY }}"></i></td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </ap-accordion>
                  }
                </ap-accordion-group>
              </div>
}
              <br>
              <br>
              @if (selectedGrpObjKeys.length === 0) {
<div class="row" style="margin: 10px 0px 0px 20px">
                <label><strong>No Business Hierarchy Found</strong></label>
              </div>
}
            </div>
            <!-- Place holder for Bizz Hierarchy Preview -->
            <div class="col-md-8 biz-hier-col">
              @if (busHierarchyLoading || busHierarchiesLoading) {
<div class="loading-overlay">
                <ap-loading [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
              </div>
}
              @if (selectedGrpObjKeys.length > 0) {
<div class="biz-hier-content">
                @for (item of bizzHierarchies; track $index) {
<div>
                  @if (item.visible) {
<div class="panel panel-default biz-hier-panel">
                    <div class="panel-heading">Selected Business Hierarchy
                      <div class="pull-right">
                        <button class="btn btn-info btn-xs" type="button" (click)="saveBus(item.group_obj_key)">
                          @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
                        </button>
                        <button class="btn btn-warning btn-xs" type="button" (click)="cancelBus()">Cancel</button>
                      </div>
                    </div>
                    <div class="gt-dark-cnt">
                      <gt-business-assign-menu [callBackService]="'UserAdminFactory'" [menuData]="item.value"
                        [renderingMode]="previewMode" [userId]="logged_in_user" [loading]="loading"
                        [taxYear]="taxYear" [reportingMonth]="reportingMonth" [clientKey]="client_key"
                        [groupObjKey]="0"></gt-business-assign-menu>
                    </div>
                  </div>
}
                </div>
}
              </div>
}
            </div>
          </div>
        </div>
      </div>

</div>

  